import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";
import "../../styling/Donut.css";

const AnalyticsLeadDonut = () => {
  const [leadData, setLeadData] = useState({
    friends: 0,
    website: 0,
    socialMedia: 0,
    other: 0,
  });

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/events`, { withCredentials: true });
      const events = response.data.data;

      const counts = {
        friends: 0,
        website: 0,
        socialMedia: 0,
        other: 0,
      };

      events?.forEach(event => {
        const ref = event.eventRef;
        if (ref === "friends") counts.friends++;
        else if (ref === "website") counts.website++;
        else if (ref === "socialMedia") counts.socialMedia++;
        else counts.other++;
      });

      setLeadData(counts);
    } catch (error) {
      console.error("Error fetching lead sources:", error);
    }
  };

  const total =
    leadData.friends +
    leadData.website +
    leadData.socialMedia +
    leadData.other;

  const percentages = {
    friends: ((leadData.friends / total) * 100).toFixed(0),
    website: ((leadData.website / total) * 100).toFixed(0),
    socialMedia: ((leadData.socialMedia / total) * 100).toFixed(0),
    other: ((leadData.other / total) * 100).toFixed(0),
  };

  const data = {
    labels: ["Friends or Family", "Website", "Social Media", "Other"],
    datasets: [
      {
        data: [
          percentages.friends,
          percentages.website,
          percentages.socialMedia,
          percentages.other,
        ],
        backgroundColor: ["#260F99", "#21A62C", "#FFC700", "#F99600"],
        hoverBackgroundColor: ["#260F99", "#21A62C", "#FFC700", "#F99600"],
      },
    ],
  };

  const labels = data.labels.map((label, i) => ({
    label,
    value: data.datasets[0].data[i],
    backgroundColor: data.datasets[0].backgroundColor[i],
  }));

  return (
    <div className="lead-donut" style={{paddingBottom: '20px'}}>
      <h2 style={{ paddingTop: "20px", paddingLeft: '30px', fontWeight: '500', color: '#1C1154' }}>Lead Source</h2>

      <div className="donut-lead">
        <Doughnut
          style={{ width: '120px', height: '120px' }}
          data={data}
          options={{
            cutout: '80%',
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
            },
          }}
        />
      </div>

      {/* Custom Legend */}
      <div className="custom-legend">
        {labels.map((item, index) => (
          <div key={index} className="legend-item">
            <div className="color-box" style={{ backgroundColor: item.backgroundColor }}></div>
            <div className="legend-label">{item.label}</div>
            <div className="legend-value">{item.value}%</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsLeadDonut;
